import React, { FC } from 'react';
import { Button, Card, Skeleton, Space, Tag } from 'antd';
import { useTranslate } from '@/translations';
import { FORMAT_FULL_TIME_DAYJS } from '@/utils/constants';
import { timeConverter } from '@/utils/helpers';
import { useQuestionnaireResponse } from '@/api/Questionnaire';
import { QuestionnaireReadOnly } from '@/modules/Questionnaire';
import { MetaStripSkeleton } from '@/ui/components';
import { useResponseLabels } from '../../useResponseLabels';
import { MetaStrip } from './ResponseDetailCard.styled';

interface ResponseDetailCardProps {
  responseId: number;
  onBack: () => void;
}

export const ResponseDetailCard: FC<ResponseDetailCardProps> = ({
  responseId,
  onBack,
}) => {
  const { t } = useTranslate();
  const { data } = useQuestionnaireResponse(responseId);
  const { templateTitleByKey, customerNameById } = useResponseLabels();

  const templateTitle = data
    ? (templateTitleByKey[data.templateKey] ?? data.templateKey)
    : '';
  const customerName =
    data?.customerId != null ? customerNameById[data.customerId] : undefined;

  return (
    <Card
      title={
        <Space>
          {data ? (
            <>
              <span>{templateTitle}</span>
              <Tag>v{data.templateVersion}</Tag>
            </>
          ) : (
            <Skeleton.Input active size="small" style={{ width: 180 }} />
          )}
          <span>{`R-${responseId}`}</span>
        </Space>
      }
      extra={
        <Button data-testid="response-detail-back" onClick={onBack}>
          {t('back')}
        </Button>
      }
    >
      {data ? (
        <MetaStrip>
          <span>
            {t('submittedBy')}: {data.submittedBy ?? '-'}
          </span>
          <span>
            {t('submittedAt')}:{' '}
            {data.submittedAt
              ? timeConverter(data.submittedAt, FORMAT_FULL_TIME_DAYJS)
              : '-'}
          </span>
          <span>
            {t('vin')}: {data.vin ?? '-'}
          </span>
          <span>
            {t('customer')}: {customerName ?? '-'}
          </span>
        </MetaStrip>
      ) : (
        <MetaStripSkeleton />
      )}
      <QuestionnaireReadOnly responseId={responseId} />
    </Card>
  );
};
